// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavMenuFooter_footer__V71AQ {
  display: none;
}

@media screen and (max-width: 600px) {
  .NavMenuFooter_footer__V71AQ {
    position: fixed;
    z-index: 2;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    gap: 36px;
    width: 100%;
    min-height: 77px;
    padding: 12px 36px 0;
    margin: 0;
    background: #fff;
  }
  .NavMenuFooter_footer-item__Ryy\\+s {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 36px;
  }
  .NavMenuFooter_footer-item-title__1mNQY {
    font-weight: 400;
    font-size: 8px;
    line-height: 12px;
    color: #000054;
  }
  .NavMenuFooter_footer-item-title__1mNQY a {
    text-decoration: none;
    font-weight: 400;
    font-size: 8px;
    line-height: 12px;
  }
  .NavMenuFooter_footer-item-title__1mNQY a:link, .NavMenuFooter_footer-item-title__1mNQY a:visited, .NavMenuFooter_footer-item-title__1mNQY a:hover, .NavMenuFooter_footer-item-title__1mNQY a:active {
    text-decoration: none;
    color: #000054;
  }
  .NavMenuFooter_footer-item-title__1mNQY svg {
    display: block;
    margin: 0 auto;
  }
  .NavMenuFooter_footer-item-title__1mNQY svg.NavMenuFooter_footer-dots__qOrZm {
    margin: 8px auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NavMenuFooter/NavMenuFooter.module.scss","webpack://./src/styles/sizes.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;AAIF;;AADA;EACE;IACE,eAAA;IACA,UAAA;IACA,SAAA;IACA,OAAA;IACA,aAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;IACA,gBCVqB;IDWrB,oBAAA;IACA,SAAA;IACA,gBAAA;EAIF;EADA;IACE,aAAA;IACA,sBAAA;IACA,8BAAA;IACA,mBAAA;IACA,YAAA;EAGF;EAAA;IACE,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,cE3BO;EF6BT;EAAE;IACE,qBAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;EAEJ;EAAI;IAIE,qBAAA;IACA,cExCG;EFuCT;EAKE;IACE,cAAA;IACA,cAAA;EAHJ;EAKI;IACE,gBAAA;EAHN;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.footer {\n  display: none;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .footer {\n    position: fixed;\n    z-index: 2;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    gap: 36px;\n    width: 100%;\n    min-height: sizes.$nav-menu-mobile-height;\n    padding: 12px 36px 0;\n    margin: 0;\n    background: #fff;\n  }\n\n  .footer-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    height: 36px;\n  }\n\n  .footer-item-title {\n    font-weight: 400;\n    font-size: 8px;\n    line-height: 12px;\n    color: colors.$primary9;\n\n    a {\n      text-decoration: none;\n      font-weight: 400;\n      font-size: 8px;\n      line-height: 12px;\n\n      &:link,\n      &:visited,\n      &:hover,\n      &:active {\n        text-decoration: none;\n        color: colors.$primary9;\n      }\n    }\n\n    svg{\n      display: block;\n      margin: 0 auto;\n\n      &.footer-dots {\n        margin: 8px auto;\n      }\n    }\n  }\n}\n","$breakpoint-sm: 600px;\n$breakpoint-md: 900px;\n$breakpoint-extra-lg: 2048px;\n\n$nav-menu-width: 300px;\n$nav-menu-width-md: 250px;\n\n$nav-menu-mobile-height: 77px;\n$header-height: 68px;\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"footer": `NavMenuFooter_footer__V71AQ`,
	"footer-item": `NavMenuFooter_footer-item__Ryy+s`,
	"footer-item-title": `NavMenuFooter_footer-item-title__1mNQY`,
	"footer-dots": `NavMenuFooter_footer-dots__qOrZm`
};
export default ___CSS_LOADER_EXPORT___;
